import type { SelectOption } from '~/shared/utils/types';

import type { ExplorationVolume } from '../../types/exploration';
import { buildClusterOptions } from '../../lib/filters/buildCheckboxFilterOptions';
import FilterCheckboxList from './FilterCheckboxList';

export default function ClusterNameFilter({
  volumes,
  pendingClusterFilters,
  setPendingClusterFilters,
  globalSearchQuery = '',
  isDisclosureOpen = false,
}: {
  volumes: ExplorationVolume[];
  pendingClusterFilters: SelectOption[];
  setPendingClusterFilters: (filters: SelectOption[]) => void;
  globalSearchQuery?: string;
  isDisclosureOpen?: boolean;
}) {
  const options = buildClusterOptions(volumes);

  const handleChange = (clusterName: string) => {
    const selected = pendingClusterFilters.some((f) => f.id === clusterName);
    if (selected) {
      setPendingClusterFilters(pendingClusterFilters.filter((f) => f.id !== clusterName));
    } else {
      setPendingClusterFilters([
        ...pendingClusterFilters,
        { id: clusterName, name: clusterName, group: 'clusterName' },
      ]);
    }
  };

  if (!options.length) return null;

  return (
    <FilterCheckboxList
      options={options}
      globalSearchQuery={globalSearchQuery}
      showSectionSearch
      isDisclosureOpen={isDisclosureOpen}
      isSelected={(key) => pendingClusterFilters.some((f) => f.id === key)}
      onToggle={handleChange}
      tagVariant="cluster"
    />
  );
}

export function buildClusterFilterOptions(volumes: ExplorationVolume[]) {
  return buildClusterOptions(volumes);
}
